<template>
  <div>
    <div class="form-group">
      <div class="col-md-4">
        <label class="control-label">Location Search:</label>
        <p class="help-block">
          Please enter the location of the incident and click the "Find
          Location" button
        </p>
      </div>
      <div class="col-md-8">
        <div class="input-group">
          <input
            type="text"
            name="accident_location"
            v-model="search"
            class="form-control"
          />
          <div class="input-group-btn">
            <button
              type="button"
              class="btn btn-primary"
              v-on:click="findLocation"
              name="find_location"
            >
              Find Location
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="pr-4 pl-5">
      <div :class="{ row: alignMaps }">
        <div :class="{ 'col-md-8 offset-md-4': alignMaps }">
          <div class="row" id="map-container">
            <div class="col" id="map"></div>
            <div class="col" id="streetView" v-if="streetView"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: String,
    lat: [Number, String],
    lng: [Number, String],
    streetView: {
      type: Boolean,
      default() {
        return true;
      }
    },
    alignMaps: {
      type: Boolean,
      default() {
        return false;
      }
    }
  },

  data() {
    return {
      marker: null,
      search: null
    };
  },

  computed: {
    latLng() {
      if (this.marker) {
        return {
          lat: parseFloat(this.marker.lat),
          lng: parseFloat(this.marker.lng)
        };
      }

      return {
        lat: this.lat || 52.70465666042159,
        lng: this.lng || -1.3403320287500264
      };
    }
  },

  mounted() {
    window.GoogleMapsLoader.load(google => {
      this.buildMap(this.latLng.lat, this.latLng.lng, google);
    });
  },

  methods: {
    findLocation() {
      if (this.search) {
        let request = new XMLHttpRequest();

        request.onreadystatechange = () => {
          if (request.readyState === XMLHttpRequest.DONE) {
            let data = JSON.parse(request.response);

            this.marker = {
              lat: parseFloat(data.results[0].geometry.location.lat),
              lng: parseFloat(data.results[0].geometry.location.lng)
            };

            window.locationmap.setCenter(
              new window.google.maps.LatLng(this.marker.lat, this.marker.lng)
            );

            if (this.streetView) {
              window.streetView.setPosition(this.marker);
            }

            this.$emit('input', this.search);
          }
        };

        request.open(
          'GET',
          'https://maps.googleapis.com/maps/api/geocode/json?address=' +
            this.search +
            '&key=AIzaSyCYSEv6QzAPFbjZaAXGApLUeW6nFjwDpg8',
          true
        );
        request.send();
      }
    },

    buildMap(lat, lng, google) {
      let options = {
        scrollwheel: false,
        center: {
          lat: lat,
          lng: lng
        },
        zoom: 14
      };

      window.locationmap = new google.maps.Map(
        document.getElementById('map'),
        options
      );

      if (this.streetView) {
        window.streetView = new google.maps.StreetViewPanorama(
          document.getElementById('streetView'),
          {
            position: {
              lat: lat,
              lng: lng
            },
            pov: {
              heading: 34,
              pitch: 10
            }
          }
        );
        window.locationmap.setStreetView(window.streetView);

        window.streetView.addListener('position_changed', () => {
          this.updateMarker(
            window.streetView.getPosition().lat(),
            window.streetView.getPosition().lng()
          );
        });
      }
    },

    updateMarker(lat, lng) {
      if (this.marker) {
        this.marker.lat = lat;
        this.marker.lng = lng;
      } else {
        this.marker = {
          lat: lat,
          lng: lng
        };
      }
    }
  },

  watch: {
    value: {
      handler(value) {
        this.search = value;
      },
      immediate: true
    },

    latLng(value) {
      if (value && this.search) {
        this.updateMarker(value.lat, value.lng);

        if (window.locationmap) {
          window.locationmap.setCenter(
            new window.google.maps.LatLng(this.marker.lat, this.marker.lng)
          );

          if (
            window.streetView &&
            Object.hasOwn(window.streetView, 'setPosition')
          ) {
            window.streetView.setPosition(this.marker);
          }

          this.$emit('located', {
            latitude: value.lat,
            longitude: value.lng,
            pitch: window.locationmap?.streetView?.pov?.pitch,
            heading: window.locationmap?.streetView?.pov?.heading
          });
        }
      }
    }
  }
};
</script>
